// 立即訂閱

import Image from "next/image";
import CRMask from "../CRMask";
import SubscribeItem from "../common/SubscribeItem";
import { SUBSCRIBE_CONTENT } from "../common/constant";

const CRSubscribeInput =({
    email,
    submitError,
    onChangeEmail,
    onChangeSubmitError,
    sendEmail,
}) => {

    return(
        <div className="subscribe-wrap w-[1440px] h-screen 
            relative text-center flex flex-col center-center
            umd:w-full usm:h-[fit-content] umd:pb-[115px] 
        ">

            {/* 人物及遮罩 */}
            <div className="subscribe-img-left statue-and-mask w-[450px] h-[700px] 
                absolute left-0 top-0 translate-x-[-120px] translate-y-[150px]
                umd:scale-[.35] umd:translate-x-[-220px] umd:translate-y-[-200px] 
                pointer-events-none
            ">
                {/* 影片遮罩 */}
                <div className="mask-container m-auto w-[443px] h-[330px]">
                    <CRMask />
                </div>
                {/* 雕像 */}
                <div className="cr-statue w-[415px] h-[654px] absolute m-auto top-0 left-[-60px] z-[3] scale-x-[-1]">
                    <Image
                        alt="man-image"
                        width={415}
                        height={654}
                        src={"/images/cryptoread/section3/section3.svg"}
                        className="aspect-[415/654] absolute"
                    />
                </div>
            </div>

            <SubscribeItem
                type={'page'}
                email={email}
                submitError={submitError}
                onChangeEmail={onChangeEmail}
                onChangeSubmitError={onChangeSubmitError}
                sendEmail={sendEmail}
                info={SUBSCRIBE_CONTENT}
            />


            {/* 人物及遮罩 */}
            <div className="subscribe-img-right statue-and-mask w-[657px] h-[700px] 
                absolute bottom-0 right-0 translate-x-[125px] translate-y-[100px]
                umd:translate-x-[300px] umd:translate-y-[170px] umd:scale-[.4] 
                usm:h-full
                pointer-events-none 
            ">
                {/* 影片遮罩 */}
                <div className="mask-container-right m-auto w-[543px] h-[733px] absolute right-0 top-0">
                    <CRMask />
                </div>
                {/* 雕像 */}
                <div className="cr-statue w-[657px] max-h-[657px] h-full relative m-auto top-0 right-0 z-[3] translate-x-[60px] translate-y-[40px]">
                    <Image
                        alt="man-image"
                        width={657}
                        height={657}
                        src={"/images/cryptoread/section1/sculpture.svg"}
                        className="absolute"
                    />
                </div>
            </div>
        </div>
    )
}

export default CRSubscribeInput;